import clsx from 'clsx';

export function Spinner({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' }) {
  const dim = size === 'sm' ? 'h-3.5 w-3.5 border' : 'h-4 w-4 border-2';
  return (
    <span
      className={clsx(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        dim,
        className,
      )}
      aria-hidden
    />
  );
}
